import React from 'react';
import { Route } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import './index.css';

const { Header } = AntLayout;

// Define layout
class Layout extends React.Component {
	render() {
		return (
			<div className="app-container-register">
				<Header
					style={{
						backgroundColor: '#34464f',
						display: 'flex',
						alignItems: 'center',
						padding: '0 16px',
						height: 54
					}}
				>
					<img src="/assets/images/logo.png" alt="logo" style={{ height: 40 }} />
				</Header>
				{this.props.children}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

const ConnectedLayout = connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(Layout));

export default ({ component: Component, ...rest }) => {
	return (
		<Route
			{...rest}
			render={matchProps => (
				<ConnectedLayout>
					<Component {...matchProps} />
				</ConnectedLayout>
			)}
		/>
	);
};
